import * as React from 'react';
import { Helmet } from "react-helmet";
import { withRouter, RouteComponentProps } from 'react-router-dom';
import ContactPage from "@components/Contact";

interface Props extends RouteComponentProps { }

const ContactContainer: React.SFC<Props> = (props: Props) => {
    const title = 'Contact - Nick Avasiloi | Full Stack Web Developer, Artificial Intelligence Specialist';
    const description = 'Get in touch with Nick Avasiloi by filling simple form with 3 questions';
    const url = process.env.REACT_APP_URL + props.location.pathname;

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta name="og:title" content={title} />
                <meta name="og:description" content={description} />
                <meta name="og:url" content={url} />
                <meta name="og:image" content={`${process.env.REACT_APP_URL}/images/contact.gif`} />
            </Helmet>
            <ContactPage />
        </>
    );
}

const ContactContainerRouted = withRouter(ContactContainer);
export default ContactContainerRouted;



// WEBPACK FOOTER //
// ./src/containers/Contact/index.tsx